import { useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { Modal } from "react-bootstrap";
import CustomImageUpload from "../../component/CustomImageUpload";
import { toast } from "react-toastify";
import Icons from "../../myIcon/Icons";

const addEndpoint = ApiEndpoints.operation.Create;

export default function AddOperation({ show, onHide }) {
  const [postData, setPostData] = useState({name:""});
  
  const handleSubmit = async (event) => {
    event.preventDefault();

      if (!postData.name) {
        toast.error("Location Name is required.");
        return;
      }

      try {
        const response = await ApiRequest("POST", addEndpoint, postData);
        if(response.error === true){
          toast.error(response.message);
        }else {
          toast.success(response.message);
          onHide();
        }
        
      } catch (error) {
        console.error("There was an error creating the author!", error);
        toast.error("Failed to create author");
      }
  };


    const handleChange = (e) => {
    const { name, value } = e.target;
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      })); };

  return (
    <>
      <Modal className="add-modal-area" show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Body>
          <button className="modal-close-button" onClick={onHide}><Icons name="cross"/></button>
          <form onSubmit={handleSubmit}>
             <div className="add-page-sections">Add Department </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Department  Name<small>*</small></label>
                    </div>
                    <input name="name" type="text" onChange={handleChange} required className="form-control" placeholder="Enter Here"/>
                  </div>
                </div>
              </div>
            <button type="submit" className="default-btn">add<span></span></button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
